import { TransferWindowState, type League } from './types'

export type TeamSquadLink = { userId: string; gw?: string }

/**
 * Resolves where a team-name click should navigate to view that member's squad,
 * or `null` when the squad isn't viewable yet.
 *
 * - Window closed: link to the member's current (locked) squad.
 * - Window open: link to the previous gameweek's historical squad — the current
 *   squad is hidden until the window closes. On GW1 there is no prior squad, so null.
 */
export function teamSquadLink(userId: string, league: League): TeamSquadLink | null {
  const { currentGameweek, windowState } = league.gwStatus
  if (currentGameweek === null) return null
  if (windowState === TransferWindowState.Open) {
    if (currentGameweek <= 1) return null
    return { userId, gw: String(currentGameweek - 1) }
  }
  return { userId }
}
